var _path, _path2, _g, _circle, _path3, _path4, _path5, _path6, _path7, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 220,
    viewBox: "0 0 272 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3245 66.1925C15.4065 55.3146 22.6698 44.9414 33.5477 43.0234L189.794 15.4729C200.672 13.5549 211.045 20.8183 212.963 31.6961L213.313 33.6833L215.225 44.5249L217.137 55.3665L224.783 98.7331L236.604 165.77C238.522 176.648 231.259 187.021 220.381 188.939L64.1345 216.49C53.2566 218.408 42.8834 211.144 40.9654 200.266L29.1449 133.229L21.4983 89.8629L19.5866 79.0212L17.6749 68.1796L17.3245 66.1925Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9336 78.0222L213.618 44.0468L211.486 31.9566C209.712 21.8946 200.116 15.1759 190.054 16.9502L33.8082 44.5006C23.7461 46.2748 17.0275 55.87 18.8017 65.932L20.9336 78.0222ZM17.3245 66.1925C15.4065 55.3146 22.6698 44.9414 33.5477 43.0234L189.794 15.4729C200.672 13.5549 211.045 20.8183 212.963 31.6961L236.604 165.77C238.522 176.648 231.259 187.021 220.381 188.939L64.1345 216.49C53.2566 218.408 42.8834 211.144 40.9654 200.266L17.3245 66.1925ZM213.878 45.524L235.127 166.03C236.901 176.092 230.182 185.688 220.12 187.462L63.874 215.012C53.812 216.787 44.2168 210.068 42.4426 200.006L21.194 79.4994L213.878 45.524Z",
    fill: "#313D53"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_7087_117069)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 12,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.807 34.7151H125.058C125.058 36.5207 123.594 37.9845 121.788 37.9845H120.807V34.7151Z",
    fill: "#313D53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.193 24.907C135.193 28.8793 131.972 32.0996 128 32.0996C126.952 32.0996 125.956 31.8753 125.058 31.4721V34.0612H120.807V24.907C120.807 20.9346 124.028 17.7144 128 17.7144C131.972 17.7144 135.193 20.9346 135.193 24.907ZM124.077 24.907C124.077 22.9241 125.831 21.3107 127.994 21.3107C130.157 21.3107 131.923 22.9241 131.923 24.907C131.923 26.8898 130.157 28.5033 127.994 28.5033C125.831 28.5033 124.077 26.8882 124.077 24.907Z",
    fill: "#313D53"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 193.75,
    cy: 32.0696,
    r: 5.29751,
    transform: "rotate(-10 193.75 32.0696)",
    fill: "#313D53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.062 38.3392C182.127 37.975 183.507 36.0054 183.142 33.9399C182.778 31.8745 180.809 30.4954 178.743 30.8596C176.678 31.2237 175.299 33.1934 175.663 35.2588C176.027 37.3242 177.997 38.7034 180.062 38.3392ZM180.322 39.8164C183.204 39.3083 185.128 36.5608 184.62 33.6795C184.112 30.7982 181.364 28.8743 178.483 29.3823C175.601 29.8904 173.677 32.638 174.186 35.5193C174.694 38.4006 177.441 40.3244 180.322 39.8164Z",
    fill: "#313D53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.714 40.869C167.78 40.5048 169.159 38.5352 168.795 36.4697C168.431 34.4043 166.461 33.0251 164.395 33.3893C162.33 33.7535 160.951 35.7231 161.315 37.7886C161.679 39.854 163.649 41.2332 165.714 40.869ZM165.975 42.3462C168.856 41.8381 170.78 39.0905 170.272 36.2093C169.764 33.328 167.016 31.4041 164.135 31.9121C161.254 32.4202 159.33 35.1678 159.838 38.0491C160.346 40.9303 163.094 42.8542 165.975 42.3462Z",
    fill: "#313D53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3744 146.602L14.9585 144.347L25.1461 166.921L45.2558 152.465L36.8399 150.21L46.3111 114.863L32.8456 111.255L23.3744 146.602ZM33.9063 113.092L24.4351 148.439L17.6278 146.615L25.7592 164.633L41.8101 153.095L35.0028 151.271L44.474 115.924L33.9063 113.092Z",
    fill: "#313D53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8475 111.255L46.313 114.863L40.2244 137.586L36.8418 150.21L45.2578 152.465L34.5 160.198L28.6287 127L32.8475 111.255Z",
    fill: "#313D53"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1816 196.102V148.162L64 154.286V148.086L74.1816 142H79.7796V196.102H74.1816Z",
    fill: "#D6D8DD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_7087_117069)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 91,
    width: 102,
    height: 56,
    rx: 6,
    transform: "rotate(-10 100 91)",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.934 101.636C122.701 99.9404 125.239 98.4353 127.49 97.7286L127.49 97.7303C128.726 97.3466 132.174 96.95 133.43 97.0553C138.021 97.4185 141.98 99.3589 144.907 102.668L145.743 103.614L137.686 105.114L137.558 105.137C129.8 106.587 129.608 106.623 128.745 107.147C126.488 108.474 124.941 110.979 124.931 113.325C124.946 113.679 124.914 114.044 124.871 114.165C124.817 114.337 118.257 106.766 117.796 105.999C117.584 105.646 119.468 103.019 120.934 101.636ZM115.763 114.241C115.694 112.657 116.096 109.851 116.609 108.409C116.826 107.8 117.046 107.289 117.092 107.281C117.156 107.27 119.432 109.93 122.153 113.179C126.091 117.874 127.31 119.238 128.129 119.812C130.418 121.442 133.531 121.645 135.953 120.321C136.338 120.107 136.668 119.951 136.706 119.976C136.743 120.002 135.901 122.334 134.851 125.157L132.924 130.3L132.332 130.355C131.402 130.438 129.176 130.098 127.578 129.615C120.768 127.574 116.035 121.424 115.763 114.241ZM136.682 107.555C139.047 109.24 140.268 112.005 139.842 114.766C139.776 115.217 138.51 118.844 137.035 122.851C135.555 126.84 134.346 130.147 134.355 130.195C134.388 130.384 136.551 129.904 137.899 129.423C144.776 126.958 149.171 120.662 149.07 113.447C149.046 110.814 148.493 108.598 147.263 106.145L146.61 104.843L135.602 106.784L136.68 107.555L136.682 107.555ZM126.369 112.599C126.692 110.833 127.623 109.462 129.158 108.474L129.162 108.477C129.907 108.002 130.231 107.896 131.529 107.699C132.881 107.511 133.177 107.523 134.191 107.818C135.529 108.198 136.649 109.013 137.492 110.198C137.989 110.892 138.092 111.199 138.348 112.653C138.607 114.122 138.613 114.431 138.374 115.285C138.042 116.551 137.029 118 135.954 118.741C135.23 119.26 134.94 119.36 133.471 119.619C132.016 119.876 131.693 119.884 130.871 119.655C129.467 119.269 128.322 118.491 127.504 117.366C126.887 116.548 126.763 116.209 126.497 114.987C126.244 113.828 126.216 113.393 126.369 112.599Z",
    fill: "#313D53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.168 100.401C172.174 100.401 172.18 100.399 172.168 100.401V100.401ZM167.861 99.1203C167.866 99.1193 167.873 99.1182 167.861 99.1203V99.1203ZM192.077 98.0002C191.06 96.4092 189.285 94.814 188.048 94.4229C189.293 96.0707 190.15 97.8003 190.589 99.1191L190.599 99.147C187.921 94.8415 184.443 93.53 181.149 89.9189C180.985 89.736 180.82 89.5521 180.653 89.3574C180.566 89.258 180.491 89.1565 180.409 89.0484C180.267 88.8598 180.148 88.6552 180.054 88.4388C180.05 88.4174 180.031 88.4031 180.008 88.4018L179.975 88.4076L179.97 88.4139C179.965 88.4148 179.959 88.4213 179.959 88.4213C179.959 88.4213 179.958 88.416 179.963 88.4086C176.683 91.1943 175.834 95.2124 175.863 97.6619C174.747 97.9283 173.692 98.405 172.754 99.0665C172.669 99.1291 172.61 99.2208 172.588 99.3242C172.566 99.4276 172.583 99.5354 172.636 99.6271C172.664 99.6779 172.703 99.7223 172.75 99.7573C172.796 99.7923 172.85 99.8172 172.907 99.8304C172.964 99.8436 173.023 99.8449 173.08 99.8341C173.137 99.8233 173.192 99.8007 173.24 99.7678C174.058 99.191 174.976 98.7719 175.948 98.532L176.041 98.5035C176.174 98.4745 176.312 98.4436 176.446 98.42C177.243 98.2742 178.056 98.2448 178.862 98.3328L179.002 98.3488C179.138 98.3647 179.269 98.3869 179.405 98.4103C179.5 98.4278 179.601 98.4452 179.697 98.4681C179.774 98.482 179.853 98.5034 179.93 98.5186C180.051 98.5502 180.172 98.5862 180.293 98.6222L180.456 98.6675C180.577 98.7046 180.695 98.7457 180.812 98.7891C180.886 98.8168 180.959 98.8437 181.034 98.8769C182.354 99.402 183.521 100.25 184.43 101.342C183.447 100.884 181.765 100.548 180.303 101.082C186.733 102.994 186.938 113.448 178.681 114.507C177.771 114.633 176.845 114.583 175.953 114.361C175.852 114.334 175.752 114.307 175.652 114.278C173.461 113.594 171.458 111.923 170.833 109.579C170.833 109.579 171.093 106.619 175.764 105.796C176.272 105.706 177.467 104.04 177.423 103.628C177.387 103.496 174.327 102.864 173.019 101.962C172.319 101.482 171.991 101.247 171.702 101.079C171.545 100.986 171.383 100.903 171.216 100.832C170.611 99.5876 170.352 98.2038 170.464 96.8248C168.909 97.8924 167.814 99.3394 167.05 100.578L167.04 100.58C166.243 99.8692 165.812 97.1395 165.745 96.5653C165.733 96.5277 165.303 96.8959 165.249 96.9518C164.748 97.4651 164.288 98.0185 163.887 98.6125C163.424 99.2813 163.018 99.9875 162.673 100.724C161.882 102.406 161.431 104.227 161.348 106.084C161.327 106.605 161.328 107.127 161.349 107.648C161.35 107.779 161.354 107.911 161.361 108.042C161.37 108.363 161.394 108.683 161.432 109.002L161.435 109.053C161.458 109.239 161.478 109.42 161.499 109.606L161.513 109.688C163.114 118.765 171.77 124.827 180.847 123.226C188.975 121.793 194.685 114.698 194.64 106.715C194.632 106.5 194.616 106.284 194.601 106.068C194.433 103.194 193.549 100.292 192.08 97.9997L192.077 98.0002Z",
    fill: "#313D53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_7087_117069",
    x: 87,
    y: -1,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7087_117069"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7087_117069",
    result: "effect2_dropShadow_7087_117069"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7087_117069",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_7087_117069",
    x: 75,
    y: 60.2878,
    width: 160.175,
    height: 122.861,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7087_117069"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7087_117069",
    result: "effect2_dropShadow_7087_117069"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7087_117069",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertStep1);
export default __webpack_public_path__ + "static/media/alert-step1.6d4c0996f10fd2925e873a093bd00a5c.svg";
export { ForwardRef as ReactComponent };